import { extendTheme } from "@chakra-ui/react";

export const darkTheme = extendTheme({
    color:{
      text:{
        primary: "white"
      }
    },
    background:{
      primary: "black",
      secondary: "orange"
    }
});